import { ArtworkApprovalsState } from "../../state/approvals/data.type";
import { CollectionsFilterForm } from "./collectionsFilterForm";
import { PrintingTechniqueFilterForm } from "./printingTechniqueFilterForm";
import { useArtworkApprovalContextStore } from "../../context/approvals/ArtworkApprovalsContext";
import { getCollections } from "../../helpers/collections.helper";

interface iArtworkSearchFilterFormProps {
  onUpdateFilter: (...args: any[]) => void;
  onToggleArtworkLevel: (...args: any[]) => void;
  artworkLevel: "collection" | "printingTechnique";
  state:
    | ArtworkApprovalsState["collectionFilters"]
    | ArtworkApprovalsState["printingTechniqueFilters"];
  isLoading: boolean;
}

export const ArtworkSearchFilterForm = ({
  onUpdateFilter,
  onToggleArtworkLevel,
  artworkLevel,
  isLoading,
}: iArtworkSearchFilterFormProps) => {

  const { state, dispatch } = useArtworkApprovalContextStore();

  return (
    <div className="w-100">
      <div className="d-flex table-top-container justify-content-between mb-1">
        <div className="col-md-4 d-flex align-items-center">
          <p className="mr-3 p-0 my-0">Search for:</p>

          <fieldset className="form-group d-flex gap-2">
            <div className="form-check d-flex align-items-center mr-3">
              <input
                type="radio"
                id="collection"
                name="artwork"
                className="form-check-input d-flex"
                value="collection"
                defaultChecked={true}
                onChange={(e: any) => {
                  onToggleArtworkLevel("collection");
                }}
                checked={artworkLevel === "collection"}
              />
              <label
                className="form-check p-0 m-0 d-flex mt-2"
                htmlFor="collection"
              >
                Collection
              </label>
            </div>

            <div className="form-check d-flex align-items-center">
              <input
                type="radio"
                id="printing-technique"
                name="artwork"
                className="form-check-input"
                value="printing-technique"
                onChange={(e: any) => {
                  onToggleArtworkLevel("printingTechnique");
                }}
                checked={artworkLevel === "printingTechnique"}
              />
              <label
                className="form-check form-check-inline mt-2"
                htmlFor="printing-technique"
              >
                Artwork
              </label>
            </div>
          </fieldset>
        </div>
      </div>

      <div className="d-flex table-top-container justify-content-between mb-3">
        {artworkLevel === "collection" && <CollectionsFilterForm/>}
        {artworkLevel === "printingTechnique" && (
          <PrintingTechniqueFilterForm />
        )}
      </div>
    </div>
  );
};
